module.exports = __webpack_public_path__ + "img/tiany.46ba156c.png";